import { getTranslatedProperty } from '@shopware/helpers'
import type { Schemas } from '#shopware'

export const useUseGetCategoryName = (category: Schemas['Category']) => {
  return computed<string>(() => {
    if (category.breadcrumb?.length > 4) {
      return getTranslatedProperty(category, 'customFields')
        .novu_jp_custom_categories_parent_category_name
    } else {
      return getTranslatedProperty(category, 'name')
    }
  })
}
